export const ABHA_WIDGET_LOGO = 'https://acko-seo-prod.ackoassets.com/_next_static/images/AbhaWidgetLogo.png'
